/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/controllers/publishedReportController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:41 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import templatePopLoader from '../../../generic/views/loader.html';
class PublishedReportsController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state,
        $stateParams, pulishedReportCardsConstants, $mdDialog, CONSTANTS) {

        let self = this
        let school_id = localStorageService.get('school_id')
        localStorageService.set('attendance_save_not' , false)
        let user_id = localStorageService.get('user_id')
        self.selected_year = localStorageService.get('academic_year');
        
        if ($stateParams.fee_status) {
            user_id = $stateParams.student_id
        }
        var rcApproveYear = localStorageService.get('rcApproveYear')
        var feeStatus = $stateParams.fee_status
        $scope.fee_status_label = true
        $scope.loading = true
        var nofeeCheck = false
        if (pulishedReportCardsConstants.NO_FEESCHOOLIDS.indexOf(school_id) !== -1) {
            nofeeCheck = true
        }

        $scope.$watch(function () {
            return localStorageService.get('st_id')
        }, function (newVal, oldVal) {
            if ($rootScope.userRoleParentAccess) {
                user_id = newVal
                self.scData = []
                self.publishedReports = []
                getLoadForParent(user_id)
            }
        });
        function getLoadForParent(user_id){
            authService.callAPI("/v0/school/details/student/" + school_id+"/"+user_id, "GET", {}, function (response) {
                try{
                    $scope.studentDoc = response.result.data.details.user_doc
                    // getPublishedReports(user_id, self.selected_year)
                    self.scData = response.result.data.details.schoolDet[0].academic_year
                    let acdYear = _.find(self.scData, function (oneY) {
                        return oneY.status == 'active'
                    })
                    if (acdYear) {
                        if (rcApproveYear) {
                            self.selected_year = rcApproveYear
                        } else {
                            self.selected_year = acdYear.year
                        }
                    }else{
                        if(self.scData && self.scData.length){
                            let len = self.scData.length
                            self.selected_year = self.scData[len-1].year
                        }
                    }
                    if (!$rootScope.userRoleParentAccess){
                        getPublishedReports(user_id, self.selected_year)
                    }else{
                        getPublishedReports(user_id, self.selected_year)
                        // $scope.fee_status_label = false
                    }
                    if (!$rootScope.userRoleParentAccess){    
                        $scope.loading = false
                    }
                    $scope.$apply()
                }catch(e){
                    console.log(e)
                }
            })
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Published Reports"
            $rootScope.userRoleParentAccess = undefined
            if ($stateParams.fee_status == 'false')
                $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            } else {
                authService.callAPI("/v0/school/details/student/" + school_id+"/"+user_id, "GET", {}, function (response) {
                    try {
                        self.scData = response.result.data.details.schoolDet[0].academic_year
                        let acdYear = _.find(self.scData, function (oneY) {
                            return oneY.status == 'active'
                        })
                        if (acdYear) {
                            if (rcApproveYear) {
                                self.selected_year = rcApproveYear
                            } else {
                                self.selected_year = acdYear.year
                            }
                        }
                        if (!$rootScope.userRoleParentAccess)
                            getPublishedReports(user_id, self.selected_year)
                        // $scope.loading = false
                        $scope.$apply()
                    } catch (ex) {
                        console.log(ex);
                    }
                })
            }
            pushLog();
        }

        $scope.hideLoader = () => {
            $mdDialog.hide()
        }
        $scope.showLoader = (infoMsg) => {
            $mdDialog.show({
                locals: {
                    infoMsg: infoMsg,
                    parentScopeObj: $scope,
                },
                template: templatePopLoader,
                bindToController: true,
                controllerAs: '$ctrl',
                controller: ['$scope', '$mdDialog',
                    function ($scope, $mdDialog) {
                        $scope.infoMsg = this.infoMsg
                    }
                ],
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: true
            })
        }
        function getSchoolTokens(schoolId) {
            var dummySchool = [{
                "_id": "2ebFyzgjEwmdvep5L",
                "school_name": "The Oxford School,Trivandrum",
                "domain": "oxfordtvm.com",
                "site_url": "http://35.200.145.155:3000",
                "node_socket_url": "http://35.200.145.155:3002",
                "file_server": "http://35.200.145.155:4000",
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "53d553cca766bb843eeb6464608ac93e"
            },
            {
                "_id": "Mvb8uY53ijBX9DNJS",
                "school_name": "The Oxford School,Kollam",
                "domain": "oxfordkollam.com",
                "site_url": "http://35.200.145.155:3000",
                "node_socket_url": "http://35.200.145.155:3002",
                "file_server": "http://35.200.145.155:4000",
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "25c921722bec9527d59eb0e34713347c"
            },
            {
                "_id": "f5BCz8T7LqzpFsSP3",
                "school_name": "The Oxford School,Calicut",
                "domain": "oxfordcalicut.com",
                "site_url": "http://35.200.145.155:3000",
                "node_socket_url": "http://35.200.145.155:3002",
                "file_server": "http://35.200.145.155:4000",
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "aa8d7f8e0352b2712b9e80cf25bb60d4"
            },
            {
                "_id": "CPpbKPQTcuG97i3kv",
                "school_name": "The New Indian Model School,Dubai",
                "domain": "nimsdxb.com",
                "site_url": "http://35.189.123.171:3000",
                "node_socket_url": "http://35.189.123.171:3002",
                "file_server": "http://35.189.123.171:4000",
                // "school_data_url" : "https://portal.nimsdxb.com/index.php/portal_data_contract",
                // "school_data_token" : "e370c37780b957637493e9727c9b304d",
                // "school_data_url" : "http://qnap.ddns.cyberoam.com:3000/rims-tools/api/App",
                // "school_data_token" : "ed0a5a7f2b76668e8a6dd3388868c068"
                "school_data_url" : "https://sqa.globtech.in/bm-school-2/api/App",
                "school_data_token" : "7a9d733269d23bc35b04b56dc855d330"
            },
            {
                "_id": "m2LMtqaESFZf6xDE8",
                "school_name": "The Central School,Dubai",
                "domain": "centralschool.net",
                "site_url": "http://35.189.123.171:3000",
                "node_socket_url": "http://35.189.123.171:3002",
                "file_server": "http://35.189.123.171:4000",
                // "school_data_url" : "https://portal.centraldxb.com/index.php/portal_data_contract",
                // "school_data_token" : "f2f78f635a660af6257dab8da79c650f"
                "school_data_url" : "https://sqa.globtech.in/bm-school-2/api/App",
                "school_data_token" : "47e2b919b8551d762e1dd1f5769b66ba"
            },
            {
                "_id": "2FwuqhgeoKt6SQiCG",
                "school_name": "The New Indian Model School,Al-Ain",
                "domain": "nimsalain.com",
                "site_url": "http://35.189.123.171:3000",
                "node_socket_url": "http://35.189.123.171:3002",
                "file_server": "http://35.189.123.171:4000",
                // "school_data_url" : "https://portal.nimsalain.com/index.php/portal_data_contract",
                // "school_data_token" : "874d4634f7c741f397045aeb7fd133c6"
                "school_data_url" : "https://sqa.globtech.in/bm-school-2/api/App",
                "school_data_token" : "0ae409a7d98dde57b35a4643d2354906"
            },
            {
                "_id": "ps4vyLJhQvPZjfxaH",
                "school_name": "The New Indian Model School,Sharjah",
                "domain": "nimsshj.com",
                "site_url": "http://35.189.123.171:3000",
                "node_socket_url": "http://35.189.123.171:3002",
                "file_server": "http://35.189.123.171:4000",
                // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
                // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
                "school_data_url" : "https://sqa.globtech.in/bm-school-2/api/App",
                "school_data_token": "99d351fe9165be1c0cf35fa0a0885c17"
            }, 
            {
                "_id": "apX7mQ9LsV2kZdFaH",
                "school_name": "APEX Vision Model School, Sharjah",
                "domain": "apexsharjah.com",
                "site_url": "http://35.189.123.171:3000",
                "node_socket_url": "http://35.189.123.171:3002",
                "file_server": "http://35.189.123.171:4000",
                // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
                // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
                "school_data_url" : "https://sqa.globtech.in/bm-school-2/api/App",
                "school_data_token": "fe8acc83e277e3112e1dbf520291bfc9"
            },
            {
                "_id" : "EDcRnWShllFrmAuh",
                "school_name" : "The Model School,Abu Dhabi",
                "domain": "themodel.ae",
                "site_url" : "http://104.199.53.109:3700",
                "node_socket_url": "http://35.189.123.171:3002",
                "file_server" : "http://104.199.53.109:4000",
                "school_data_url" : "https://portal.themodel.ae/index.php/portal_data_contract",
                "school_data_token" : "7b4f98b8d9f1f00fc0a6ebab23b82d40"
            }]
            let ex = _.find(dummySchool, function (one) {
                return one._id == schoolId
            })
            return ex
        }
        function getPublishedReports(child, passedSelectedYear) {
            // alert(1)
            $scope.loading = true
            console.log(nofeeCheck)
            if (feeStatus == "true" || nofeeCheck) {
                $scope.fee_status_label = true
                $scope.loading = true
                getReportCardList(child, passedSelectedYear)
            } else {
                $scope.fee_status_label = true
                let tokens = getSchoolTokens(school_id)
                // $scope.showLoader("Please wait..")
                let admn_no = localStorageService.get('admission_no')
                if(!admn_no){
                    if($scope.studentDoc && $scope.studentDoc.admission_number){
                        admn_no = $scope.studentDoc.admission_number
                    }
                }
                authService.callAPI("/v0/parent/portal/fee/", "POST", {
                    school_data_token: tokens.school_data_token,
                    school_data_url: tokens.school_data_url,
                    admn_no: admn_no
                }, function (response) {
                    try {
                        if (response.result.status.code == 200) {
                            if (response.result.data && response.result.data.details) {
                                self.feesDocument = response.result.data.details
                                var exmpList = (response.result.data.exemption_list)?response.result.data.exemption_list:[]; 
                                _.each(self.feesDocument, function (det, index) {
                                    if(det.fee_last_date){
                                        let someDate = new Date(det.fee_last_date);
                                        let numberOfDaysToAdd = 20;
                                        someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                                        det.fee_last_date = someDate
                                    }
                                    // det.fee_last_date = new Date(det.fee_last_date)
                                    let today = new Date()
                                    det.fee_last_date.setHours(0, 0, 0, 0);
                                    today.setHours(0, 0, 0, 0);
                                    if (det.fee_last_date <= today) {
                                        if (det.fee_status === "Pending" && det.blocking_status === "Y") {
                                            // console.log(exmpList)
                                            var isExepted = exmpList.includes(admn_no);
                                            if(isExepted){
                                                $scope.fee_status_label = true
                                            } else {
                                                $scope.fee_status_label = false
                                            }
                                        } else {
                                            $scope.fee_status_label = true
                                        }
                                    }
                                })
                                getReportCardList(child, passedSelectedYear)
                            } else {
                                $scope.fee_status_label = true
                                getReportCardList(child, passedSelectedYear)
                            }
                        } else {
                            $scope.fee_status_label = false
                        }
                        $scope.hideLoader()
                    } catch (ex) {
                        $scope.hideLoader()
                        console.log(ex);
                    }
                    $scope.$apply()
                })
            }
        }
        self.listRcWithSelectedYear = (selected_year) => {
            if (selected_year) {
                localStorageService.set({
                    acdYearRcStudent: selected_year
                })
            }
            self.selected_year = selected_year
            $scope.loading = true
            if(selected_year  !== localStorageService.get('academic_year')){
                getReportCardList(user_id, self.selected_year)
                $scope.fee_status_label = true
            }else{
                getPublishedReports(user_id, self.selected_year)
            }  
            
            
        }
        function getReportCardList(child, passedSelectedYear) {
            let forCt = false
            if ($stateParams.fee_status == 'true') {
                forCt = true
            }

            let requestBody = {
                args: {
                    schoolId: school_id,
                    user_id: child,
                    passedSelectedYear: passedSelectedYear,
                    forCt: forCt,
                    is_web : true,
                    parent_status:(localStorageService.get('role_ids').indexOf('Rt4ZwrDRxw8Zwer6aC') !== -1)?true:false,
                    student_status:(localStorageService.get('role_ids').indexOf('student') !== -1)?true:false

                }

            }
            console.log(localStorageService.get('role_ids') )
            if (localStorageService.get('role_ids').indexOf('Rt4ZwrDRxw8Zwer6aC') !== -1 ) {
                console.log(localStorageService.get('role_ids').indexOf('Rt4ZwrDRxw8Zwer6aC') )
                $scope.isAdmUsr = true; 
              }
            authService.callAPI("/v0/reportcards/published/list", "POST", requestBody, function (response) {
                try {
                    self.publishedReports = response.result.data.details.arrayToClient
                } catch (ex) {
                    self.publishedReports = []
                }
                $scope.loading = false
                $scope.$apply()
            })
        }

        this.$onDestroy = () => {

        }
        $scope.showReportCard = function (consoleId, type, asset_format, card) {

            // HPC report card → generate + download the PDF instead of routing to reportsMain
            if (card && card.is_hpc) {
                $scope.downloadHpcReport(card);
                return;
            }

            if(card.attendance_butn_not){
                localStorageService.set('attendance_save_not' , true)
            }
            let obj = {
                student_id: user_id,
                console_id: consoleId,
                type: type ? type : false,
                template_view: "cbse",
                asset_format: asset_format ? asset_format : false,
                selected_year: self.selected_year,
                kb_consolidated: card.kb_consolidated ? true : false,
                kg_consolidated: card.kg_consolidated ? true : false,
                montessori_consolidated: card.montessori_consolidated ? true : false
            }
            obj['for_ct'] = false
            if ($stateParams.fee_status) {
                obj['for_ct'] = true
            }
            
            $state.go('reportsMain', obj)
        }
        $scope.showEducoreReportCard = function (consoleId, type, asset_format, card) {
            let obj = {
                student_id: user_id,
                console_id: consoleId,
                type: type,
                template_view: "educore",
                selected_year: self.selected_year,
                asset_format: asset_format ? asset_format : false,
                kb_consolidated: card.kb_consolidated ? true : false,
                kg_consolidated: card.kg_consolidated ? true : false,
                montessori_consolidated : false
            }
            if(card.attendance_butn_not){
                localStorageService.set('attendance_save_not' , true)
            }
            obj['for_ct'] = false
            if ($stateParams.fee_status) {
                obj['for_ct'] = true
            }
            $state.go('reportsMain', obj)
        }

        // ── HPC report card: generate on the server, download the returned PDF ──
        $scope.downloadHpcReport = function (card) {
            let sheetRecordId = (card && (card.sheet_record_id || card.report_console_id)) || undefined
            let admn = localStorageService.get('admission_no') ||
                ($scope.studentDoc && $scope.studentDoc.admission_number) || undefined
            if (!sheetRecordId || !admn) {
                toastr.error('Missing report details (sheet / admission number).')
                return
            }
            $scope.loading = true
            authService.callAPI('/v0/hpc/report-card/generate', 'POST', {
                sheet_record_id: sheetRecordId,
                admission_number: admn,
                fileUpload: CONSTANTS.FILE_UPLOAD_URL
            }, function (response) {
                try {
                    let res = response && response.result && response.result.data
                    if (res && res.success && res.data && res.data.pdf_base64) {
                        // Only announce success if the blob/download step actually ran —
                        // it has its own failure path that toasts an error.
                        if (_downloadBase64Pdf(res.data.pdf_base64, res.data.filename || 'HPC_Report.pdf')) {
                            toastr.success('Downloaded HPC report')
                        }
                    } else {
                        toastr.error((res && res.message) || 'Failed to generate HPC report')
                    }
                } catch (ex) {
                    console.log(ex)
                    toastr.error('Failed to generate HPC report')
                }
                $scope.loading = false
                _.defer(function () { $scope.$apply(); })
            })
        }

        // Convert a base64 PDF to a Blob, trigger a browser download, and open the
        // same PDF in a new tab so the parent can read it without hunting for the file.
        function _downloadBase64Pdf(base64, filename) {
            try {
                let byteChars = atob(base64)
                let byteNumbers = new Array(byteChars.length)
                for (let i = 0; i < byteChars.length; i++) {
                    byteNumbers[i] = byteChars.charCodeAt(i)
                }
                let byteArray = new Uint8Array(byteNumbers)
                let blob = new Blob([byteArray], { type: 'application/pdf' })
                let urlCreator = window.URL || window.webkitURL
                let url = urlCreator.createObjectURL(blob)
                let link = document.createElement('a')
                link.href = url
                link.download = filename
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                // View copy — a separate object URL, so revoking the download's URL
                // can never pull the PDF out from under the open tab.
                let viewUrl = urlCreator.createObjectURL(blob)
                let tab = window.open(viewUrl, '_blank')
                if (!tab) {
                    // Pop-up blocked — the download still succeeded, so this is a hint,
                    // not an error.
                    toastr.info('Allow pop-ups to view the report in a new tab')
                    urlCreator.revokeObjectURL(viewUrl)
                } else {
                    // Give the new tab time to load before releasing the blob. Revoking
                    // on a 1s timer like the download URL can blank the viewer.
                    setTimeout(function () { urlCreator.revokeObjectURL(viewUrl) }, 60000)
                }

                setTimeout(function () { urlCreator.revokeObjectURL(url) }, 1000)
                return true
            } catch (ex) {
                console.log(ex)
                toastr.error('Could not download the PDF')
                return false
            }
        }

        function pushLog(){
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+user_id+"/"+school_id+"/publishedReports_Listing", "GET", {},function (response) {
                  // console.log(response)
            });
        }
    }
}

export default PublishedReportsController;



// WEBPACK FOOTER //
// ./src/app/report_cards/published_reports/controllers/publishedReportController.js